import * as React from "react";
import { SVGProps, memo } from "react";

const SvgDrugPinLg = (props: SVGProps<SVGSVGElement>) => (
  <svg width={68} height={78} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#DrugPinLg_svg__a)">
      <mask id="DrugPinLg_svg__b" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 0a8 8 0 0 0-8 8v36a8 8 0 0 0 8 8h12.227L34 62l5.773-10H52a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H16Z"
        />
      </mask>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 0a8 8 0 0 0-8 8v36a8 8 0 0 0 8 8h12.227L34 62l5.773-10H52a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H16Z"
        fill="#2BA168"
      />

      <path
        d="m28.227 52 .866-.5-.29-.5h-.576v1ZM34 62l-.866.5L34 64l.866-1.5L34 62Zm5.773-10v-1h-.577l-.288.5.865.5ZM9 8a7 7 0 0 1 7-7v-2a9 9 0 0 0-9 9h2Zm0 36V8H7v36h2Zm7 7a7 7 0 0 1-7-7H7a9 9 0 0 0 9 9v-2Zm12.227 0H16v2h12.227v-2Zm6.639 10.5-5.773-10-1.733 1 5.774 10 1.732-1Zm4.041-10-5.773 10 1.732 1 5.773-10-1.732-1ZM52 51H39.773v2H52v-2Zm7-7a7 7 0 0 1-7 7v2a9 9 0 0 0 9-9h-2Zm0-36v36h2V8h-2Zm-7-7a7 7 0 0 1 7 7h2a9 9 0 0 0-9-9v2ZM16 1h36v-2H16v2Z"
        fill="#26734C"
        mask="url(#DrugPinLg_svg__b)"
      />
    </g>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m34 13.763 11.667 5.49v19.248H22.333V19.254L34 13.764Zm-14.166 4.962c0-.646.372-1.233.957-1.508l12.5-5.883c.449-.211.97-.211 1.419 0l12.5 5.883c.584.275.957.862.957 1.508v20.609c0 .92-.746 1.666-1.667 1.666h-25c-.92 0-1.666-.746-1.666-1.666v-20.61Zm13.282 3.06a4.786 4.786 0 0 1 6.768 6.767l-5 5a4.786 4.786 0 0 1-6.768-6.768l5-5Zm5 1.767a2.286 2.286 0 0 0-3.232 0l-2.45 2.45 3.233 3.232 2.45-2.45a2.286 2.286 0 0 0 0-3.232Z"
      fill="#fff"
    />

    <defs>
      <filter
        id="DrugPinLg_svg__a"
        x={0}
        y={0}
        width={68}
        height={78}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />

        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />

        <feOffset dy={8} />

        <feGaussianBlur stdDeviation={4} />

        <feComposite in2="hardAlpha" operator="out" />

        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />

        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_24437_53897" />

        <feBlend in="SourceGraphic" in2="effect1_dropShadow_24437_53897" result="shape" />
      </filter>
    </defs>
  </svg>
);

const Memo = memo(SvgDrugPinLg);

export default Memo;
